import React, { PropsWithChildren } from "react";

import { css, cx } from "@emotion/css";
import ListSubheader from "@mui/material/ListSubheader";

import { FontSizes } from "@/assets/fonts.ts";
import { useStyles } from "@/hooks/useStyles.ts";
import { AtomProps, StyleClasses } from "@/uiKit/atoms/utils/AtomTypes.ts";

export type BaseSelectCategoryProps = PropsWithChildren<{}>;

export type SelectCategoryProps = AtomProps<BaseSelectCategoryProps, StyleClasses<"root">>;

export const SelectCategory: React.FC<SelectCategoryProps> = ({ id, className, classes, children, ...props }) => {
  const styles = useStyles(makeStyles);

  return (
    <ListSubheader id={id} className={cx(styles.root, className)} {...props}>
      {children}
    </ListSubheader>
  );
};

const makeStyles = () => ({
  root: css({
    color: "var(--mui-palette-text-primary)",
    fontWeight: "bold",
    fontSize: FontSizes.body,
  }),
});
